import axios from 'axios';
import { config } from '../appConfig';

export const api = axios.create({
  baseURL: config.arcgisBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});